import React from 'react';

export default function Instruktur() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Instruktur</h1>
      <p className="text-gray-500">Halaman Instruktur</p>
    </div>
  );
}
